import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { profileSlice } from './userProfileSlice';
import instance from 'utils/apiCalls';
import { USER_PROFILE_URLS } from './userProfileUrls';
import { RootState } from 'redux/store';
import { ChangeNameFormDataI } from 'components/base/ChangeNameModal';

const { actions } = profileSlice;

export const getProfile =
  () =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    const response = await instance.get(USER_PROFILE_URLS.GET_PROFILE);

    if (response?.data?.permissions?.length > 0) {
      dispatch(actions.setPermissionList(response?.data?.permissions));
    }
    if (response.data.email) {
      dispatch(
        actions.setUserData({
          email: response.data.email,
          first_name: response.data.first_name,
          last_name: response.data.last_name,
          user_id: response.data.user_id,
          email_configurations: response.data.email_configurations ?? false
        })
      );
    }
    return response;
  };

export const updateProfile =
  (data: ChangeNameFormDataI, id: string) => async () => {
    const response = await instance.put(
      USER_PROFILE_URLS.UPDATE_PROFILE.replace(':id', id),
      data
    );
    return response;
  };

export const updateEmailConfig =
  (
    email_configurations: boolean,
    id: string,
    first_name: string,
    last_name: string
  ) =>
  async () => {
    const response = await instance.put(
      USER_PROFILE_URLS.UPDATE_PROFILE.replace(':id', id),
      { email_configurations, first_name, last_name }
    );
    return response;
  };
